import { Req } from './types/requests'
import { Offer, Res } from './types/responses'
import _data from './_data'

export const sdk = {
  createOfferRedemption: (params: Req['createOfferRedemption']) => {
    return _data
      .get(`offers/${params.id}/redeem`, params)
      .then((res) => res as Res['offerRedemption'])
    // return Promise.resolve(responses.offerRedemption)
  },

  getAllOffers: async (params = {}) => {
    let all: Offer[] = []
    let page = 1

    while (true) {
      const res = await sdk.getOffers({ page, page_size: 20, ...params })
      all = all.concat(res.results)
      if (!res.next) break
      page++
    }

    return { results: all }
  },
  getOffer: (params: Req['getOffer']) => {
    if (!params.id && !params.slug) {
      throw new Error('Could not retrieve offer')
      return
    }
    if (params.slug) {
      console.log(`offers/s/${params.slug}/`)
      return _data.get(`offers/s/${params.slug}`, {}).then((res) => {
        return res as Res['offer']
      })
    }
    return _data.get(`offers/${params.id}/`, params).then((res) => {
      return res as Res['offer']
    })
    // return Promise.resolve(responses.offer)
  },
  getOffers: (params: Req['getOffers']) => {
    return _data.get('offers/', params).then((res) => {
      return res as Res['offers']
    })
    // const { tags } = params as { tags: string[] }
    // const response = responses.offers.results.filter((offer) =>
    //   offer.tags.includes(tags[0]),
    // )
    // return Promise.resolve(responses.offers)
  },
  getTags: (params: Req['getTags']) => {
    return _data.get('tags/', params).then((res) => {
      return res as Res['tags']
    })
    // return Promise.resolve(responses.tags)
  },
  login: (params: Req['login']) => {
    // return _data.post('login/', params).then((res) => {
    //   return res
    // })
    return Promise.resolve()
  },
}
